import {
  createCommentId,
  resolveLoggedInUser,
} from '../../elements/VideoPlayer/videoAnnotationStorage';

export { createCommentId, resolveLoggedInUser };

export interface ImageComment {
  id: string;
  userId: string;
  userName: string;
  text: string;
  createdAt: number;
}

// key = image url
export type ImageAnnotations = Record<string, ImageComment[]>;

const STORAGE_KEY = 'geneo_image_annotations_v1';

const readAll = (): ImageAnnotations => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as ImageAnnotations) : {};
  } catch (error) {
    console.error('Failed to read image annotations from localStorage', error);
    return {};
  }
};

const writeAll = (data: ImageAnnotations): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error('Failed to persist image annotations to localStorage', error);
  }
};

const sortByCreatedAt = (comments: ImageComment[]): ImageComment[] =>
  [...comments].sort((a, b) => a.createdAt - b.createdAt);

export const getImageComments = (url: string): ImageComment[] => {
  const all = readAll();
  return sortByCreatedAt(all[url] || []);
};

export const saveImageComments = (
  url: string,
  comments: ImageComment[]
): void => {
  const all = readAll();
  if (comments.length > 0) {
    all[url] = sortByCreatedAt(comments);
  } else {
    delete all[url];
  }
  writeAll(all);
};

export const addImageComment = (
  url: string,
  comment: ImageComment
): ImageComment[] => {
  const next = sortByCreatedAt([...getImageComments(url), comment]);
  saveImageComments(url, next);
  return next;
};

export const deleteImageComment = (
  url: string,
  commentId: string
): ImageComment[] => {
  const next = getImageComments(url).filter((c) => c.id !== commentId);
  saveImageComments(url, next);
  return next;
};
